import { render, staticRenderFns } from "./CertificationTile.vue?vue&type=template&id=fed4d45c&scoped=true&"
import script from "./CertificationTile.vue?vue&type=script&lang=js&"
export * from "./CertificationTile.vue?vue&type=script&lang=js&"
import style0 from "./CertificationTile.vue?vue&type=style&index=0&id=fed4d45c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed4d45c",
  null
  
)

export default component.exports